module.exports = __webpack_public_path__ + "static/parallax-96e494a509a1722796db1c7025b4ea4a.webp";